import { ICubeResponse } from "@spawn/backend-adapter-cube";
import { consumer, GameTime, inject } from "@spawn/core";
import { INetworkState } from "@spawn/networking";
import { CacheKeys, CacheStorage } from "../../utils/cacheStorage";
import { INrgCubeGameResult } from "../types/cube";
import { FGSpinActionCube } from "./fgSpinActionCube";

@consumer
export class FGPseudoSpinActionCube extends FGSpinActionCube {
	@inject private readonly gameTime!: GameTime;

	public async execute(): Promise<INetworkState> {
		await this.gameTime.waitFor(0.2);
		const response = CacheStorage.get<ICubeResponse<INrgCubeGameResult>>(CacheKeys.FirstFGSpinResponse);
		return this.parse(response, this.adapter);
	}
}
